import React, { useEffect, useState, useRef } from 'react';

const WhyChoose = () => {




  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);
  const goldColor = "#fc7303";

  useEffect(() => {
    const currentElem = sectionRef.current;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          if (currentElem) observer.unobserve(currentElem);
        }
      },
      {
        threshold: 0.6,
        rootMargin: "0px 0px -50px 0px"
      }
    );

    if (currentElem) {
      observer.observe(currentElem);
    }

    return () => {
      if (currentElem) {
        observer.unobserve(currentElem);
      }
    };
  }, []);



  return (
    <div>

      <style>{`
                 /* --- INITIAL STATE (HIDDEN) --- */
        .feature-item {
          opacity: 0;
          transform: translateY(20px);
        }

        /* --- TRIGGER ANIMATIONS ONLY WHEN VISIBLE --- */
        .is-visible .feature-item {
          animation: fadeInUp 0.6s ease forwards;
        }

        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }

        /* Staggered Delays */
        .is-visible .delay-1 { animation-delay: 0.1s; }
        .is-visible .delay-2 { animation-delay: 0.3s; }
        .is-visible .delay-3 { animation-delay: 0.5s; }
        .is-visible .delay-4 { animation-delay: 0.7s; }
        .is-visible .delay-5 { animation-delay: 0.9s; }

        /* --- TRUCK SLIDE-IN (ONLY WHEN VISIBLE) --- */
        @keyframes truckSlideIn {
          0% { transform: translateX(-2550%); opacity: 0; }
          70% { transform: translateX(100px); opacity: 1; }
          100% { transform: translateX(0); opacity: 1; }
        }

        .anim-truck-container {
          display: inline-block;
          opacity: 0;
        }

        .is-visible .anim-truck-container {
          animation: truckSlideIn 2.2s cubic-bezier(0.25, 1, 0.5, 1) forwards;
          animation-delay: 1.1s;
        }

        /* SPEED LINES EFFECT */
        @keyframes speedLines {
          0% { opacity: 0; transform: translateX(0); }
          50% { opacity: 1; transform: translateX(-5px); }
          100% { opacity: 0; transform: translateX(-15px); }
        }

        .speed-line {
          stroke: ${goldColor};
          stroke-width: 2;
          animation: speedLines 0.3s infinite linear;
        }

        /* Hide speed lines after truck stops (after 2.3s total) */
        @keyframes fadeOutLines {
          0%, 90% { opacity: 1; }
          100% { opacity: 0; visibility: hidden; }
        }
       .is-visible .speed-line-group {
  animation: fadeOutLines 1s linear infinite;
}

        /* --- WHEEL ROTATION --- */
        @keyframes wheelRotate {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        .is-visible .anim-wheel { 
          animation: wheelRotate 0.5s infinite linear; 
          transform-origin: center; 
          transform-box: fill-box; 
        }

        /* --- OTHER ICON ANIMATIONS --- */
        .is-visible .anim-shield { animation: shieldPulse 2s infinite ease-in-out; animation-delay: 1s; }
        @keyframes shieldPulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.1); }
        }

/* --- CUSTOM MADE PENCIL ANIMATION --- */
.anim-pencil {
  transform-origin: center;
}

/* Pencil writing motion */
.is-visible .anim-pencil {
  animation: pencilWrite 1.8s ease-in-out infinite;
}

@keyframes pencilWrite {
  0%, 100% {
    transform: rotate(0deg) translate(0, 0);
  }
  25% {
    transform: rotate(-12deg) translate(2px, -2px);
  }
  50% {
    transform: rotate(-18deg) translate(4px, -3px);
  }
  75% {
    transform: rotate(-10deg) translate(2px, -1px);
  }
}

/* WRITING LINES */
.write-line {
  stroke: var(--light-gold);
  stroke-width: 1.8;
  stroke-linecap: round;
  opacity: 0;
}

/* Animate writing effect */
.is-visible .write-line-1 {
  animation: drawLine 1.8s infinite;
}

.is-visible .write-line-2 {
  animation: drawLine 1.8s infinite 0.25s;
}

.is-visible .write-line-3 {
  animation: drawLine 1.8s infinite 0.5s;
}

@keyframes drawLine {
  0% {
    stroke-dasharray: 0 20;
    opacity: 0;
  }
  20% {
    opacity: 1;
  }
  60% {
    stroke-dasharray: 20 0;
    opacity: 1;
  }
  100% {
    stroke-dasharray: 20 0;
    opacity: 0;
  }
}

        /* --- LAYOUT --- */
        .feature-divider { border-right: 1px solid rgba(255,255,255,0.1); }
        @media (max-width: 991px) {
          .feature-divider { border-right: none; border-bottom: 1px solid rgba(255,255,255,0.05); padding-bottom: 20px; }
          .feature-item { margin-bottom: 20px; }
        }
        .feature-title {
          font-family: 'Oswald', sans-serif;
          font-size: 0.85rem;
          text-transform: uppercase;
          margin-top: 15px;
          letter-spacing: 1px;
        }
        .feature-desc {
          font-size: 11px;
          color: #aaa;
          max-width: 140px;
          margin: 0 auto;
          line-height: 1.4;
        }




        /* FAST DELIVERY TEXT INITIAL STATE */
.fast-delivery-text {
  opacity: 0;
  transform: translateY(30px);
}

/* Trigger after truck animation */
.is-visible .fast-delivery-text {
  animation: fastDeliveryTextReveal 0.9s ease-out forwards;
  animation-delay: 2s;
}

/* Smooth upward reveal */
@keyframes fastDeliveryTextReveal {
  0% {
    opacity: 0;
    transform: translateY(30px);
  }

  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
        `}</style>


      <section
        ref={sectionRef}
        className={isVisible ? "is-visible" : ""}
        style={{ background: "#0d0d0d", color: "white", padding: "80px 0", overflow: "hidden" }}
      >
        <div className="container text-center">
          <h5 style={{ color: goldColor, letterSpacing: "3px", fontWeight: "600", marginBottom: "50px" }}>
            WHY CHOOSE US
          </h5>

          <div className="row g-0">

            {/* 1. PREMIUM QUALITY */}
            <div className="col-lg col-6 feature-item delay-1 feature-divider">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke={goldColor} strokeWidth="1.5" className="anim-shield">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                <path d="M9 12l2 2 4-4" strokeLinecap="round" />
              </svg>
              <h6 className="feature-title">Premium Quality</h6>
              <p className="feature-desc">Fine materials for long lasting performance.</p>
            </div>

            {/* 2. CUSTOM MADE */}
            <div className="col-lg col-6 feature-item delay-2 feature-divider">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke={goldColor} strokeWidth="1.5" className="anim-pencil">
                <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z" />
              </svg>
              <h6 className="feature-title">Custom Made</h6>
              <p className="feature-desc">Customized doors as per your requirements.</p>
            </div>

            {/* 3. TRUSTED BRANDS */}
            <div className="col-lg col-6 feature-item delay-3 feature-divider">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke={goldColor} strokeWidth="1.5">
                <circle cx="12" cy="8" r="7" />
                <path d="M8.21 13.89L7 23l5-3 5 3-1.21-9.12" />
              </svg>
              <h6 className="feature-title">Trusted Brands</h6>
              <p className="feature-desc">Authorized dealers of top-quality brands.</p>
            </div>

            {/* 4. AFFORDABLE PRICE */}
            <div className="col-lg col-6 feature-item delay-4 feature-divider">
              <svg
                width="40"
                height="40"
                viewBox="0 0 24 24"
                fill="none"
                stroke={goldColor}
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M7 6h10" />
                <path d="M7 10h10" />
                <path d="M7 6h4a4 4 0 1 1 0 8H7" />
                <path d="M7 14l8 6" />
              </svg>

              <h6 className="feature-title">Affordable Price</h6>

              <p className="feature-desc">
                Best quality products at competitive prices.
              </p>
            </div>

            {/* 5. FAST DELIVERY */}
            <div className="col-lg col-12 feature-item delay-5">
              <div className="anim-truck-container">
                <svg width="60" height="40" viewBox="0 0 35 24" fill="none">
                  <g className="speed-line-group">
                    <line className="speed-line" x1="0" y1="8" x2="6" y2="8" style={{ animationDelay: '0s' }} />
                    <line className="speed-line" x1="-2" y1="12" x2="4" y2="12" style={{ animationDelay: '0.1s' }} />
                    <line className="speed-line" x1="0" y1="16" x2="6" y2="16" style={{ animationDelay: '0.2s' }} />
                  </g>
                  <path d="M8 5h14v12H8z" stroke={goldColor} strokeWidth="1.5" />
                  <path d="M22 9h5l3 3v5h-8V9z" stroke={goldColor} strokeWidth="1.5" />
                  <circle className="anim-wheel" cx="12" cy="19" r="2.5" stroke={goldColor} strokeWidth="1.5" strokeDasharray="2 1" />
                  <circle className="anim-wheel" cx="26" cy="19" r="2.5" stroke={goldColor} strokeWidth="1.5" strokeDasharray="2 1" />
                </svg>
              </div>
              <h6 className="feature-title fast-delivery-text">Fast Delivery</h6>
              <p className="feature-desc fast-delivery-text">
                On-time delivery with safe & secure packaging.
              </p>
            </div>

          </div>
        </div>
      </section>
    </div>
  )
}

export default WhyChoose